function localStorageConfig(app) {
	app.config(['localStorageServiceProvider', function (localStorageServiceProvider) {
		localStorageServiceProvider
			.setPrefix('ebiz')
			.setStorageType('localStorage')
			.setNotify(true, true);
	}]);
}

export default localStorageConfig;
